import React, { useState } from 'react';
import { Form, FormCheckbox, FormGroup, Button, Header, Icon } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { Consts, Styles } from '../../../res';

const { carouselExamItemButton } = Styles;


const filterTypes = {
    UNATTEMPTED: "UNATTEMPTED",
    ATTEMPTED: "ATTEMPTED",
    FLAGGED: "FLAGGED",
    WRONG: "WRONG",
    CORRECT: "CORRECT"
};

const ExamSummary = ({ questions, onSelectQuestion, summary, Qindex, isViewOnly, isMockExam }) => {

    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === "ar";
    const [filters, setFilters] = useState([]);
    const [lock, setLock] = useState(false);


    const handleChange = (value) => {
        if (filters.includes(value)) return setFilters(prev => prev.filter(f => f !== value));
        return setFilters(prev => [...prev, value]);
    };

    const selectColor = (q) => {
        if (!isMockExam && q.questionTypeId === Consts.QUESTIONS_TYPES.MCQS && q?.answerOptionId)
            return (q.isPassed || (q.answerOptionId == q?.correctAnswer?.correctAnswerOptionId)) ? "green" : "red";
        if (q.questionTypeId === Consts.QUESTIONS_TYPES.MCQS ? q.answerOptionId : q.answerText) return '#4c4c4c';
        return '#8CC63F';
    };

    return (

        <div className={`tw-h-full tw-flex tw-flex-col tw-shadow-2xl`}>


            <div className='tw-h-10 tw-px-2 tw-bg-CMA_BLACK tw-flex tw-flex-row tw-items-center tw-justify-between'>
                <p className='tw-text-WHITE'>{t("ReviewAnswers")}</p>
                <div className='tw-flex tw-flex-row tw-items-center'>
                    <div><Icon size='small' name={lock ? "lock" : "unlock"} circular link onClick={() => setLock(prev => !prev)} className='tw-text-white tw-cursor-pointer tw-bg-green-500 ' /></div>
                    <div><Icon size='small' name="x" circular link onClick={() => summary.setShowSummary(!summary.show)} className='tw-text-white tw-cursor-pointer tw-bg-green-500 ' /></div>
                </div>
            </div>


            <div className='tw-flex-1 tw-overflow-y-auto'>
                <div className='tw-bg-gray-200 tw-p-5'>
                    <Header>{t("FilterBy")}</Header>
                    <Form>
                        <FormGroup grouped>
                            <FormCheckbox
                                label={t("Unattempted")}
                                value={filterTypes.UNATTEMPTED}
                                checked={filters.includes(filterTypes.UNATTEMPTED)}
                                onChange={() => handleChange(filterTypes.UNATTEMPTED)}
                            />
                            {(isViewOnly) && <FormCheckbox
                                label={t("Wrong")}
                                value={filterTypes.WRONG}
                                checked={filters.includes(filterTypes.WRONG)}
                                onChange={() => handleChange(filterTypes.WRONG)}
                            />}
                            <FormCheckbox
                                label={t("Attempted")}
                                value={filterTypes.ATTEMPTED}
                                checked={filters.includes(filterTypes.ATTEMPTED)}
                                onChange={() => handleChange(filterTypes.ATTEMPTED)}
                            />
                            <FormCheckbox
                                label={t("Flagged")}
                                value={filterTypes.FLAGGED}
                                checked={filters.includes(filterTypes.FLAGGED)}
                                onChange={() => handleChange(filterTypes.FLAGGED)}
                            />
                            {(isViewOnly) && <FormCheckbox
                                label={t("Correct")}
                                value={filterTypes.CORRECT}
                                checked={filters.includes(filterTypes.CORRECT)}
                                onChange={() => handleChange(filterTypes.CORRECT)}
                            />}
                        </FormGroup>
                        <div className='tw-flex tw-justify-end tw-my-3'>
                            <Button
                                disabled={!filters.length}
                                content={t("Clear")}
                                style={{ ...carouselExamItemButton, backgroundColor: "#8CC63F" }}
                                onClick={() => setFilters([])}
                            />
                        </div>
                    </Form>
                </div>

                <div className='tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-5 tw-flex-wrap tw-py-5'>
                    {
                        questions.filter(q => !(q?.showFactOnly)).map((q, index) => {
                            const isFlagged = q.isFlagged;
                            const isAttempted = q?.answerOptionId || q?.answerText || q?.answerJson;
                            const isUnAttempted = !isAttempted;
                            const isCorrect = (isViewOnly) && q?.isPassed;
                            const isWrongAnswerd = (isViewOnly) && isAttempted && q?.isPassed === 0;
                            const questionStatus = [];

                            isFlagged && questionStatus.push(filterTypes.FLAGGED);
                            isAttempted && questionStatus.push(filterTypes.ATTEMPTED);
                            isUnAttempted && questionStatus.push(filterTypes.UNATTEMPTED);
                            isWrongAnswerd && questionStatus.push(filterTypes.WRONG);
                            isCorrect && questionStatus.push(filterTypes.CORRECT);

                            if (filters.length === 0 || filters.every(f => questionStatus.includes(f)))


                                return <div key={q.questionId} className='tw-relative'>
                                    {(q.answerOptionId || q.answerText) && <div className='tw-absolute tw-border-t-[12px] tw-border-t-white tw-border-e-[12px] tw-border-e-transparent tw-start-0 tw-top-0 tw-w-3 tw-h-3 tw-bg-[#bac4cb] tw-z-10' />}
                                    <Button
                                        content={q?.qFactIndex !== undefined ? `${t("E")}.${q.qFactIndex + 1}` : q?.qAterFactIndex !== undefined ? q.qAterFactIndex : index + 1}
                                        icon={q.isFlagged ? 'flag' : null}
                                        style={{ ...carouselExamItemButton, backgroundColor: isViewOnly ? (isCorrect ? "#8CC63F" : isWrongAnswerd ? "red" : isAttempted ? "#4c4c4c" : "gray") : selectColor(q), clipPath: Qindex === index ? isArabic ? 'polygon(25% 0%, 100% 0%, 100% 100%, 25% 100%, 0% 50%)' : 'polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)' : null }}
                                        onClick={() => {
                                            if (!lock) summary.setShowSummary(false);
                                            onSelectQuestion(q);
                                        }}
                                    />
                                </div>;
                            return null;
                        })}
                </div>
            </div>



            <div className='tw-bg-CMA_BLACK tw-h-10' />
        </div>

    );
};

export default ExamSummary;;